<template>
    <div 
        v-if="isStudent"
        class="student bg-color-secondary"
    >
        <a
            @click="onClickLogout"
        >
            <span 
                v-bastards
                class="student-name fs-13"
                v-text="`Student: ${studentData.name}`"
            />
            <span class="student-info fs-15">Wyloguj się</span>
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        isStudent() {
            return this.$store.getters['apiStudent/isAuth']
        },
        studentData() {
            return this.$store.getters['apiStudent/student']
        }
    },

    methods: {
        onClickLogout() {
            this.$store.dispatch('siteLoader/open', 'white')

            this.$store.dispatch('apiStudent/logout').finally(() => {
                this.$store.dispatch('siteLoader/close')
            })
        }
    }
}
</script>

<style lang="scss">
.student {
    @include transition(.100s);
    cursor: pointer;
    display: inline-block;
    position: fixed;
    text-align: right;
    padding: 8px 15px;
    right: 0;
    bottom: 20px;
    z-index: 3020;

    &-name,
    &-info {
        display: block;
    }

    &:hover {
        &.bg-color-secondary {
            background-color: $color-primary;
            color: $color-default-contrast;
        }
    }
}
</style>
